<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-4 mt-5 tit-edit">
      <h3>Dados da Faculdade</h3>
    </div>
    <div class="d-flex align-items-center justify-content-between mt-3">
      <div class="d-flex align-items-center">
        <i class="fas fa-university"></i>
        <div>
          <label for="faculdade">Faculdade</label>
          <input type="text" readonly class="form-control-plaintext" id="faculdade" v-model="faculdade.nome">
        </div>
      </div>
    </div>
    <hr/>
    <div class="d-flex align-items-center justify-content-between mt-3">
      <div class="d-flex align-items-center">
        <i class="fas fa-globe-americas"></i>
        <div>
          <label for="paisFaculdade">País da faculdade</label>
          <input type="text" readonly class="form-control-plaintext" id="paisFaculdade" v-model="faculdade.pais">
        </div>
      </div>
    </div>
    <hr/>
    <div class="d-flex align-items-center justify-content-between mt-3">
      <div class="d-flex align-items-center">
        <i class="fas fa-map-marked"></i>
        <div>
          <label for="ufFaculdade">UF</label>
          <input type="text" readonly class="form-control-plaintext" id="ufFaculdade" v-model="faculdade.uf">
        </div>
      </div>
    </div>
    <hr/>
    <div class="d-flex align-items-center justify-content-between mt-3">
      <div class="d-flex align-items-center">
        <i class="fas fa-flag"></i>
        <div>
          <label for="contato">Contato na faculdade</label>
          <input type="text" readonly class="form-control-plaintext" id="contato" v-model="faculdade.contato.nome">
          <small class="form-text text-muted">{{ faculdade.contato.telefone }}</small>
        </div>
      </div>
    </div>

    <div v-if="$empresaUtils.temAcesso($tipoAcesso.DADOS_ACADEMICOS_MEUS_DADOS.nome, $configEmpresa.rotasRestritasAcesso)">
      <div class="d-flex align-items-center justify-content-between mb-4 mt-5 tit-edit">
        <h3>Meus Dados</h3>
        <a href="javascript:void(0);" class="btn btn-perfil" @click="$bvModal.show('modalFaculdade')">{{ $t('btn.editar')
          }}</a>
      </div>
      <div class="d-flex align-items-center justify-content-between mt-3">
        <div class="d-flex align-items-center">
          <i class="fas fa-graduation-cap"></i>
          <div>
            <label for="anoFormacao">Ano de início</label>
            <input type="text" readonly class="form-control-plaintext" id="anoFormacao" v-model="faculdade.anoInicio">
          </div>
        </div>
      </div>
      <hr/>
      <div class="d-flex align-items-center justify-content-between mt-3">
        <div class="d-flex align-items-center">
          <i class="far fa-calendar"></i>
          <div>
            <label for="semestreInicio">Semestre de início</label>
            <input type="text" readonly class="form-control-plaintext" id="semestreInicio"
                  v-model="translateSemestreInicio">
          </div>
        </div>
      </div>
      <hr/>
      <div class="d-flex align-items-center justify-content-between mt-3">
        <div class="d-flex align-items-center">
          <i class="fas fa-map-pin"></i>
          <div>
            <label for="periodoAtual">Período atual</label>
            <input type="text" readonly class="form-control-plaintext" id="periodoAtual" v-model="translatePeriodoAtual">
          </div>
        </div>
      </div>
    </div>

    <b-modal hide-footer id="modalFaculdade" body-class="modal-conteudo py-4" header-class="">
      <template slot="modal-title">
        <h5 class="modal-title">Meus dados acadêmicos</h5>
      </template>
      <form>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="ano-formacao">Ano de início</label>
              <select class="form-control" id="ano-formacao" name="ano-formacao"
                      v-model="faculdadeAlteracao.anoInicio">
                <option v-for="anoInicio in montarAnosInicioFaculdade()" :value="anoInicio">{{anoInicio}}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="semestre-inicio">Semestre de Início</label>
              <select class="form-control" id="semestre-inicio" name="semestre-inicio"
                      v-model="faculdadeAlteracao.semestreInicio">
                <option value="1">1º</option>
                <option value="2">2º</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="periodo-atual">Período Atual</label>
              <select class="form-control" id="periodo-atual" name="periodo-atual"
                      v-model="faculdadeAlteracao.periodoAtual">
                <option value="1">1º</option>
                <option value="2">2º</option>
                <option value="3">3º</option>
                <option value="4">4º</option>
                <option value="5">5º</option>
                <option value="6">6º</option>
                <option value="7">7º</option>
                <option value="8">8º</option>
                <option value="9">9º</option>
                <option value="10">10º</option>
                <option value="11">11º</option>
                <option value="12">12º</option>
              </select>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button type="button" @click="alterarDadosFaculdade" class="btn btn-secondary my-3">Alterar dados da
            faculdade
          </button>
        </div>
      </form>
    </b-modal>

  </div>
</template>

<script>
import PerfilAPI from '@/api/perfil-api'
import Swal from 'sweetalert2'

export default {
  name: 'DadosFaculdade',
  props: {
    aluno: Object
  },
  data () {
    return {
      faculdade: {
        nome: '',
        semestreInicio: 1,
        periodoAtual: 1,
        anoInicio: 0,
        pais: 'Brasil',
        uf: '',
        contato: { nome: '', telefone: '' }
      },
      faculdadeAlteracao: {
        id: 0,
        semestreInicio: 1,
        periodoAtual: 1,
        anoConclusao: 0
      }
    }
  },
  computed: {
    translatePeriodoAtual: function () {
      if (this.faculdade.periodoAtual) {
        return `${this.faculdade.periodoAtual}º`
      }
      return ''
    },
    translateSemestreInicio: function () {
      if (this.faculdade.semestreInicio) {
        return `${this.faculdade.semestreInicio}º`
      }
      return ''
    }
  },
  watch: {
    aluno: function (aluno) {
      this.faculdade = {
        id: this.aluno.idFaculdade ? this.aluno.idFaculdade : 0,
        nome: this.aluno.siglaFaculdade,
        semestreInicio: this.aluno.semestreInicio,
        periodoAtual: this.aluno.periodoAtual,
        anoInicio: this.aluno.anoInicio,
        pais: this.aluno.paisFaculdade,
        uf: this.aluno.estadoFaculdade,
        contato: { nome: '', telefone: '' }
      }

      this.faculdadeAlteracao = Object.assign({}, this.faculdade)
    }
  },
  methods: {
    montarAnosInicioFaculdade: function () {
      const limiteAnos = 11

      let anosFormacao = []
      let year = new Date().getFullYear()

      for (let i = 0; i < limiteAnos; i++) {
        anosFormacao.push(year--)
      }

      return anosFormacao
    },

    alterarDadosFaculdade: function () {
      const loader = this.$loading.show()

      PerfilAPI
        .atualizarMeusDadosFaculdade(this.faculdadeAlteracao.id, this.faculdadeAlteracao.anoInicio, this.faculdadeAlteracao.semestreInicio, this.faculdadeAlteracao.periodoAtual)
        .then(data => {
          if (data.success && data.success === 'error') {
            if (data.status) {
              Swal.fire({
                icon: 'error',
                text: data.status
              })
            } else {
              Swal.fire({
                icon: 'error',
                text: 'Ocorreu um erro ao tentar editar os dados acadêmicos.'
              })
            }

            loader.hide()
          } else {
            Object.assign(this.faculdade, this.faculdadeAlteracao)

            loader.hide()
            this.$bvModal.hide('modalFaculdade')
          }
        })
    }
  }
}
</script>

<style scoped>

</style>
